var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGrayForward = function SvgGrayForward(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.95962 11.4596C1.70578 11.7135 1.29422 11.7135 1.04038 11.4596C0.78654 11.2058 0.78654 10.7942 1.04038 10.5404L1.95962 11.4596ZM6.5 6L6.95962 5.54038C7.21346 5.79422 7.21346 6.20578 6.95962 6.45962L6.5 6ZM1.04038 1.45961C0.786539 1.20577 0.786539 0.794215 1.04038 0.540375C1.29422 0.286534 1.70578 0.286534 1.95962 0.540375L1.04038 1.45961ZM1.04038 10.5404L6.04038 5.54038L6.95962 6.45962L1.95962 11.4596L1.04038 10.5404ZM6.04038 6.45962L1.04038 1.45961L1.95962 0.540375L6.95962 5.54038L6.04038 6.45962Z",
    fill: "#898E92"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGrayForward, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gray-forward.ba134a5a.svg";
export { ForwardRef as ReactComponent };